<template>
    <div>
        <div class="title">
            <h4>师傅管理</h4>
        </div>
        <!-- 搜索框 -->
        <div class="searchBox" ref="searchBox">
            <el-form :inline="true" :model="table.searchForm" ref="searchForm" class="demo-form-inline"
                label-width="100px" size="mini">
                <div class="inpBox">
                    <el-form-item label="姓名: " prop="idName">
                        <el-input placeholder="" v-model="table.searchForm.idName"></el-input>
                    </el-form-item>
                    <el-form-item label="手机号: " prop="phoneNum">
                        <el-input placeholder="" v-model="table.searchForm.phoneNum"></el-input>
                    </el-form-item>
                </div>
                <div class="searchBtnBox">
                    <el-form-item>
                        <el-button type="primary" @click="tableSearch">查询</el-button>
                    </el-form-item>
                    <el-form-item>
                        <el-button type="primary" @click="tableResetForm">重置</el-button>
                    </el-form-item>
                    <el-form-item>
                        <el-button type="primary" @click="editDialogOpen">新增</el-button>
                    </el-form-item>
                    <!-- <el-form-item>
                        <el-upload class="upload-demo" ref="upload" action="/bms-api/open/importData" :on-preview="handlePreview" :on-remove="handleRemove" :file-list="fileList" :auto-upload="false">
                            <el-button slot="trigger" size="small" type="primary">选取文件</el-button>
                            <el-button style="margin-left: 10px" size="small" type="success" @click="submitUpload">上传到服务器</el-button>
                            <div slot="tip" class="el-upload__tip">选择Excel</div>
                        </el-upload>
                    </el-form-item> -->
                </div>
            </el-form>
        </div>
        <div class="table" :style="{ height: table.height }">
            <el-table :data="table.tableList" ref="table" v-loading="table.loading" @row-click="tableHandleRowClick"
                highlight-current-row bordersize="mini" height="100%" style="width: 100%" center border>
                <el-table-column fixed type="index" width="55" label="序号"></el-table-column>
                <el-table-column label="操作" width="120">
                    <template slot-scope="scope">
                        <div>
                            <el-button type="text" size="mini" @click="viewDialogOpenWindow(scope.row)">查看</el-button>
                            <el-button type="text" size="mini" v-show="scope.row.status == 0"
                                @click="editStatus(scope.row, 1)">禁用</el-button>
                            <el-button type="text" size="mini" v-show="scope.row.status == 1"
                                @click="editStatus(scope.row, 0)">恢复</el-button>
                            <!-- <el-button type="text" size="mini" @click="editDialogEdit(scope.row)">编辑</el-button> -->
                            <!-- <el-button type="text" size="mini" @click="workerDelete(scope.row)">删除</el-button> -->
                        </div>
                    </template>
                </el-table-column>
                <el-table-column prop="idName" min-width="80" label="姓名">
                    <template slot-scope="scope">
                        {{ scope.row.idName ? scope.row.idName : "暂无" }}
                    </template>
                </el-table-column>
                <el-table-column prop="age" min-width="50" label="年龄">
                    <template slot-scope="scope">
                        {{ scope.row.age ? scope.row.age : "暂无" }}
                    </template>
                </el-table-column>
                <el-table-column prop="idCode" min-width="120" label="身份证号">
                    <template slot-scope="scope">
                        {{ scope.row.idCode ? scope.row.idCode : "暂无" }}
                    </template>
                </el-table-column>
                <el-table-column prop="phoneNum" min-width="120" label="手机号"></el-table-column>
                <el-table-column min-width="120" label="所属门店" prop="branch.name">
                    <template slot-scope="scope">
                        {{ scope.row.branch && scope.row.branch.name ? scope.row.branch.name : '暂无' }}
                    </template>
                </el-table-column>
                <el-table-column prop="number" min-width="120" label="工号"></el-table-column>
                <el-table-column prop="createdAt" min-width="120" label="注册时间"></el-table-column>
            </el-table>
        </div>
        <div>
            <el-pagination background @size-change="pagerHandleSizeChange" @current-change="pagerHandleCurrentChange"
                :current-page="table.searchForm.pageNo" :page-sizes="[10, 20, 50, 100]"
                :page-size="table.searchForm.pageSize" layout="total, sizes, prev, pager, next, jumper"
                :total="table.total"> </el-pagination>
        </div>
        <!-- 新建或编辑弹窗 -->
        <el-dialog :title="editDialog.title" :close-on-click-modal="false" :close-on-press-escape="false" class="vehm"
            :visible.sync="editDialog.visible" @close="editDialogClose" @opened="editDialogOpen" width="1200px" center>
            <span style="display: flex;">
                <el-form :inline="true" :rules="editDialog.rules" :model="editDialog.form" ref="editDialogForm"
                    class="demo-form-inline jiaoyan" label-width="100px" size="mini">
                    <el-form-item label="手机号:" prop="phoneNum">
                        <el-input placeholder="" v-model="editDialog.form.phoneNum"></el-input>
                    </el-form-item>
                    <span
                        style="color: red;line-height: 30px;margin-left: 20px;font-size: 12px;">绑定该手机号工人到此门店，尽快联系工人实名认证</span>
                </el-form>
            </span>
            <span slot="footer" class="dialog-footer">
                <el-button @click="editDialog.visible = false">取消</el-button>
                <el-button type="primary" @click="editDialogSave">确认</el-button>
            </span>
        </el-dialog>
        <!-- 查看 -->
        <el-dialog :title="viewDialog.title" :close-on-click-modal="false" :close-on-press-escape="false" class="vehm"
            :visible.sync="viewDialog.visible" @close="viewDialogClose" @opened="viewDialogOpen" width="1200px" center>
            <span>
                <el-form :inline="true" :model="viewDialog.form" ref="viewDialogForm" class="demo-form-inline jiaoyan"
                    label-width="100px" size="mini">
                    <el-form-item label="手机号:" prop="phoneNum">
                        <el-input placeholder="" v-model="viewDialog.form.phoneNum"></el-input>
                    </el-form-item>
                    <el-form-item label="姓名:" prop="idName">
                        <el-input placeholder="" v-model="viewDialog.form.idName"></el-input>
                    </el-form-item>
                    <el-form-item label="年龄:" prop="age">
                        <el-input placeholder="" v-model="viewDialog.form.age"></el-input>
                    </el-form-item>
                    <el-form-item label="身份证号:" prop="idCode">
                        <el-input placeholder="" v-model="viewDialog.form.idCode"></el-input>
                    </el-form-item>
                    <el-form-item label="工号:" prop="number">
                        <el-input placeholder="" v-model="viewDialog.form.number"></el-input>
                    </el-form-item>
                    <el-form-item label="籍贯:" prop="domicile">
                        <el-input placeholder="" v-model="viewDialog.form.domicile"></el-input>
                    </el-form-item>
                    <br/>
                    <el-form-item label="身份证正面:" prop="expiredAt">
                        <!-- <el-input placeholder="" v-model="viewDialog.form.expiredAt"></el-input> -->
                        <!-- <el-button type="primary" @click="lookBtn(viewDialog.form.face,1)">查看</el-button> -->
                        <el-image 
                            style="width: 100px; height: 100px"
                            :src="faceBackUrl" 
                            :preview-src-list="[faceBackUrl]">
                        </el-image>
                         <!-- {{ viewDialog.form.face }} -->
                    </el-form-item>
                    <el-form-item label="身份证反面:" prop="expiredAt">
                        <!-- <el-input placeholder="" v-model="viewDialog.form.expiredAt"></el-input> -->
                        <!-- {{ viewDialog.form.back }}     -->
                        <!-- <el-button type="primary" @click="lookBtn(viewDialog.form.back,2)">查看</el-button> -->
                        <el-image 
                            style="width: 100px; height: 100px"
                            :src="BackfaceUrl" 
                            :preview-src-list="[BackfaceUrl]">
                        </el-image>
                    </el-form-item>
                    <el-form-item label="身份证有限期:" prop="expiredAt">
                        <el-input placeholder="" v-model="viewDialog.form.expiredAt"></el-input>
                    </el-form-item>
                    <el-form-item label="注册时间:" prop="createdAt">
                        <el-input placeholder="" v-model="viewDialog.form.createdAt"></el-input>
                    </el-form-item>
                    <el-form-item label="门店:" prop="status" label-width="100px">
                         <el-select placeholder="请选择" v-model="viewDialog.form.branchId">
                            <el-option v-for="item in tableWorker.allBranches" :key="item.id"
                                :label="item.name" :value="item.id"></el-option>
                        </el-select>
                    </el-form-item>
                </el-form>
            </span>
            <span slot="footer" class="dialog-footer">
                <el-button @click="enter">保存</el-button>
                <el-button @click="viewDialog.visible = false">关闭</el-button>
            </span>
        </el-dialog>
    </div>
</template>
<script>
    /* eslint-disable */
    import { workerList, workerAdd, workerEdit, workerDelete,workergrant,branchesList } from "@/api/request";
    import { Message } from "element-ui";
    export default {
        data() {
            return {
                table: {
                    height: "500px",
                    loading: false,
                    total: 0,
                    tableList: [],
                    searchForm: {
                        pageNo: 1,
                        pageSize: 10,
                    },
                },
                tableWorker: {
                    height: "500px",
                    loading: false,
                    total: 0,
                    searchForm: {
                        pageNo: 1,
                        pageSize: 10,
                        branchId:'',
                        status:0
                    },
                    allBranches:[],
                    branchId:'',
                },
                faceBackUrl:'',
                BackfaceUrl:'',
                viewDialog: {
                    title: "查看师傅",
                    form: {},
                    visible: false,
                },
                editDialog: {
                    title: "新增师傅",
                    operation: "add",
                    form: {},
                    visible: false,
                    genderList: [
                        { value: 0, label: "男" },
                        { value: 1, label: "女" },
                        { value: 2, label: "保密" },
                    ],
                    roleList: [
                        { value: 1, label: "管理员1" },
                        { value: 2, label: "管理员2" },
                        { value: 3, label: "管理员3" },
                    ],
                    rules: {
                        account: [{ required: true, message: "请输入账号", trigger: "blur" }],
                        password: [{ required: true, message: "请输入密码", trigger: "blur" }],
                        name: [{ required: true, message: "请输入店名", trigger: "blur" }],
                        district: [{ required: true, message: "请输入所属区域", trigger: "blur" }],
                    },
                },
            };
        },
        created() {
            this.tableGetList(this.table.searchForm);
            this.branchesGetList()
        },
        mounted() {},
        methods: {
            enter(){
                
                const loading = this.$loading({
                    lock: true,
                    text: "正在处理...",
                });
                workerEdit({ id:this.viewDialog.form.id,phoneNum:this.viewDialog.form.phoneNum,status:this.viewDialog.form.status,branchId: this.viewDialog.form.branchId }).then(
                    (res) => {
                        console.log("res", res);
                        loading.close();
                        this.tableGetList(this.table.searchForm);
                    },
                    (res) => {
                        Message({
                            message: res.message,
                            type: "error",
                            duration: 1500,
                            onClose: () => {
                                loading.close();
                            },
                        });
                    }
                );
            },
            //获取所有门店
            branchesGetList(){
                branchesList().then(
                    (res) => {
                        console.log(res,'所有门店');
                        this.tableWorker.allBranches = res.data.list
                    },
                    (res) => {
                        Message({
                            message: `${res.message}`,
                            type: "error",
                            duration: 1500,
                        });
                    }
                )
            },
            lookBtn(url,type){
                workergrant({url}).then((res)=>{
                    console.log(66,res)
                    if(type==1){
                        this.faceBackUrl = res.message
                    }else{
                        this.BackfaceUrl = res.message
                    }
                    
                    
                })
                
            },
            submitUpload() {
                this.$refs.upload.submit();
            },
            handleRemove(file, fileList) {
                console.log(file, fileList);
            },
            handlePreview(file) {
                console.log(file);
            },
            // 编辑窗口: 关闭对话框后(渲染结束)执行. 恢复窗口初始状态
            editDialogClose() {
                this.$nextTick(() => {
                    this.editDialog.form = {};
                    this.editDialog.title = "新增师傅";
                    this.editDialog.operation = "add";
                    this.$refs.editDialogForm.clearValidate();
                });
            },
            // 编辑窗口: 打开. 通用设置
            editDialogOpen() {
                this.editDialog.visible = true;
            },
            // 编辑窗口: 编辑. 同时触发editDialogOpen()
            editDialogEdit(row) {
                this.editDialog.title = "编辑师傅";
                this.editDialog.visible = true;
                this.editDialog.operation = "edit";
                this.editDialog.form = row;
            },
            viewDialogClose() {
                this.$nextTick(() => {
                    this.viewDialog.form = {};
                    this.$refs.viewDialogForm.clearValidate();
                });
            },
            // 编辑窗口: 打开. 通用设置
            viewDialogOpen() {
                this.viewDialog.visible = true;
            },
            viewDialogOpenWindow(row) {
                this.viewDialog.visible = true;
                this.viewDialog.form = row;
                this.viewDialog.form.idImage = JSON.parse(this.viewDialog.form.idImage)
                this.viewDialog.form.face = this.lookBtn(this.viewDialog.form.idImage.face,1)
                this.viewDialog.form.back = this.lookBtn(this.viewDialog.form.idImage.back,2)
            },
            editDialogDelete(row) {},
            editDialogSave() {
                this.$refs.editDialogForm.validate((valid) => {
                    if (valid) {
                        // 全屏遮罩. 不是表格遮罩
                        const loading = this.$loading({
                            lock: true,
                            text: "正在处理...",
                        });
                        if (this.editDialog.operation == "add") {
                            workerAdd(this.editDialog.form)
                                .then(
                                    (res) => {
                                        Message({
                                            message: `${res.message}`,
                                            type: "success",
                                            duration: 800,
                                            onClose: () => {
                                                console.log("res", res);
                                                loading.close();
                                                this.editDialog.visible = false;
                                                this.tableGetList(this.table.searchForm);
                                            },
                                        });
                                    },
                                    (res) => {
                                        Message({
                                            message: `${res.message}`,
                                            type: "error",
                                            duration: 1500,
                                            onClose: () => {
                                                loading.close();
                                            },
                                        });
                                    }
                                )
                                .catch((error) => {
                                    console.log(error);
                                });
                        } else if (this.editDialog.operation == "edit") {
                            workerEdit(this.editDialog.form)
                                .then(
                                    (res) => {
                                        Message({
                                            message: `${res.message}`,
                                            type: "success",
                                            duration: 800,
                                            onClose: () => {
                                                console.log("res", res);
                                                loading.close();
                                                this.editDialog.visible = false;
                                                this.tableGetList(this.table.searchForm);
                                            },
                                        });
                                    },
                                    (res) => {
                                        Message({
                                            message: `${res.message}`,
                                            type: "error",
                                            duration: 1500,
                                            onClose: () => {
                                                loading.close();
                                            },
                                        });
                                    }
                                )
                                .catch((error) => {
                                    this.$message({
                                        showClose: true,
                                        message: error instanceof Object && error.message !== undefined ? error.message : "Cannot parse response",
                                        type: "error",
                                        onClose() {},
                                    });
                                });
                        }
                    }
                });
            },
            editStatus(row, value) {
                const loading = this.$loading({
                    lock: true,
                    text: "正在处理...",
                });
                workerEdit({ ...row, status: value }).then(
                    (res) => {
                        console.log("res", res);
                        loading.close();
                        this.tableGetList(this.table.searchForm);
                    },
                    (res) => {
                        Message({
                            message: res.message,
                            type: "error",
                            duration: 1500,
                            onClose: () => {
                                loading.close();
                            },
                        });
                    }
                );
            },
            workerDelete(row) {
                this.$confirm("确定进行删除操作吗?", "Tips", {
                    confirmButtonText: "确认",
                    cancelButtonText: "取消",
                }).then(
                    () => {
                        const loading = this.$loading({
                            lock: true,
                            text: "正在处理...",
                        });
                        workerDelete(row).then(
                            (res) => {
                                loading.close();
                                this.$message({
                                    message: res.message,
                                    type: "success",
                                });
                                this.tableGetList(this.table.searchForm);
                            },
                            (res) => {
                                this.$message({
                                    showClose: true,
                                    message: res.message,
                                    type: "error",
                                    onClose() {
                                        loading.close();
                                    },
                                });
                            }
                        );
                    },
                    () => {}
                );
            },
            // 表格: 列表查询方法
            tableGetList(searchForm) {
                workerList(searchForm.createTime ? { ...searchForm, createTime: `${searchForm.createTime[0]},${searchForm.createTime[1]}` } : { ...searchForm })
                    .then(
                        (res) => {
                            this.table.total = res.data.total;
                            this.table.tableList = res.data.list;
                            console.log("this.table.tableList", this.table.tableList);
                        },
                        (res) => {
                            Message({
                                message: `${res.message}`,
                                type: "error",
                                duration: 1500,
                            });
                        }
                    )
                    .catch((error) => {
                        Message({
                            message: `${error}`,
                            type: "error",
                            duration: 1500,
                        });
                    });
            },
            // 表格: 点击重置搜索条件时
            tableResetForm() {
                this.table.searchForm = {
                    pageNo: 1,
                    pageSize: 10,
                };
                this.tableGetList(this.table.searchForm);
            },
            // 表格: 点击表格的行时
            tableHandleRowClick(row, column, event) {
                this.$refs.table.toggleRowSelection(row);
            },
            // 表格: 点击搜索按钮时
            tableSearch() {
                console.log(this.table.searchForm);
                this.tableGetList(this.table.searchForm);
            },
            // 分页器: 每页条数发生变化时
            pagerHandleSizeChange(val) {
                this.table.searchForm.pageSize = val;
                this.tableGetList(this.table.searchForm);
            },
            // 分页器: 翻页时
            pagerHandleCurrentChange(val) {
                this.table.searchForm.pageNo = val;
                this.tableGetList(this.table.searchForm);
            },
        },
    };
</script>
<style lang="scss" scoped>
    .title {
        display: flex;
        justify-content: space-between;
        padding-right: 10px 10px;
        margin-left: 10px;
        border-bottom: 1px solid #dcdfe6;
        margin-bottom: 10px;
        h4 {
            margin: 0;
            font-size: 14px;
            color: #333;
            padding-bottom: 10px;
            border-bottom: 2px solid rgb(166, 59, 58);
        }
    }
    .searchBox {
        display: flex;
        .searchBtnBox {
            padding-left: 10px;
            // margin-left: 10px;
            ::v-deep .el-form-item--mini.el-form-item,
            ::v-deep .el-form-item--small.el-form-item {
                margin-bottom: 6px !important;
            }
        }
        .inpBox {
            ::v-deep .el-form-item--mini.el-form-item,
            ::v-deep .el-form-item--small.el-form-item {
                margin-bottom: 6px !important;
            }
            ::v-deep .el-form-item.long {
                width: 100%;
                margin-right: 0 !important;
            }
            ::v-deep .el-input__inner {
                width: 150px !important;
            }
            ::v-deep .el-date-editor {
                width: 350px !important;
            }
        }
    }
    .table {
        ::v-deep .el-table {
            color: #333;
            th {
                background-color: #f5f5f5;
                height: 40px;
                color: #333333 !important;
                padding: 2px 0 !important;
                &:first-child .cell {
                    padding: 0 10px 0 10px;
                }
            }
            tr {
                height: 32px;
                &:nth-child(even) {
                    background-color: #f8fafd;
                }
            }
            td {
                padding: 2px 0 !important;
            }
            .cell {
                text-align: center;
                padding: 0 10px;
            }
            .el-button--primary {
                background-color: rgb(166, 59, 58);
            }
            .el-button--primary:focus,
            .el-button--primary:hover {
                background: rgb(166, 59, 58);
                border-color: rgb(166, 59, 58);
                color: #fff;
            }
            .el-button {
                padding: 7px 15px;
            }
            .el-button--text {
                padding: 0;
            }
            .bigBtn {
                padding: 12px 28px;
            }
            .el-button--text {
                color: rgb(24, 148, 219);
            }
            .el-button--text:focus,
            .el-button--text:hover {
                color: rgb(24, 148, 219);
            }
            .el-table__body tr.hover-row > td {
                background-color: rgba(14, 110, 236, 0.3) !important;
            }
            .el-table__body tr.current-row > td {
                background-color: rgba(14, 110, 236, 0.3) !important;
            }
            .el-table--enable-row-hover .el-table__body tr:hover > td {
                background-color: rgba(14, 110, 236, 0.3) !important;
            }
        }
    }
    .el-dialog__wrapper {
        ::v-deep .el-dialog__header {
            padding: 8px 20px !important;
            background-color: rgb(166, 59, 58);
            .el-dialog__title {
                color: #fff;
            }
            .el-dialog__headerbtn {
                top: 12px;
                .el-dialog__close {
                    color: #fff;
                }
            }
        }
        .hidden ::v-deep .el-upload--picture-card {
            display: none;
        }
        .addressBox .title {
            margin-top: 0;
            margin-left: 10px;
            font-size: 14px;
            margin-bottom: 20px;
            .iconFont {
                color: rgb(166, 59, 58);
                margin-right: 4px;
                font-size: 14px;
            }
        }
        ::v-deep .el-upload--picture-card {
            background-image: url("../../assets/images/upload.png");
            background-size: 150%;
            background-position: 50% 50%;
        }
    }
</style>
